export default [

     {
          path: '/biaimpact-matrix',
          name: 'BIAImpactMatrix',
          component: () => import("@/views/Page/BIAImpactMatrix/BIAImpactMatrix.vue"),
           meta: {
               title: '#Default# | BIAImpactMatrix',
          },
     }
];